import React from 'react'
import { IconButton } from 'theme-ui'
import { FaAngleUp } from 'react-icons/fa'
import { Link } from 'gatsby'

export const BackTop = () => {

    return(<IconButton title='Back to top' alt='Back to top' as={Link} to='#header' sx={{position:'fixed', bg:'omegaLight' , bottom: 4 , right: 4}}>
        <FaAngleUp/>
        </IconButton>)
}
